
import APIClient from './APIClient'

class CTimesheetsAPI {

  async list(params) {
    const q = {}
    if (params.start_date) q.start_date = params.start_date 
    if (params.search) q.search = params.search
    const res = await APIClient.GET('/timesheets', Object.keys(q).length > 0 ? q : undefined)
    return res
  }

  async get(id) {
    const res = await APIClient.GET('/timesheets/'+id)
    return res
  }

  async updateEntry(timesheetId, entryId, entry) {
    const res = await APIClient.POST(`/timesheets/${timesheetId}/entries/${entryId}`, entry)
    return res
  }

  async approve(id) {
    const res = await APIClient.POST('/timesheets/'+id+'/approve')
    return res
  }

}

const TimesheetsAPI = new CTimesheetsAPI()

export default TimesheetsAPI



// WEBPACK FOOTER //
// ./src/api/TimesheetsAPI.js